// extracted by css-extract-rspack-plugin
export default {"ctrlTabs":"ctrlTabs-IutM7m"};